<template>
  <v-card class="card-review-container">
    <v-card-text class="pt-4">
      <!-- Student and Teacher Information -->
      <div class="review-info-section mb-4">
        <div class="d-flex align-center mb-2">
          <v-icon color="primary" class="mr-2">mdi-account</v-icon>
          <span class="font-weight-medium">{{ selectedReview.studentName }}</span>
        </div>
        
        <div class="d-flex align-center mb-2">
          <v-icon color="primary" class="mr-2">mdi-account-tie</v-icon>
          <span class="font-weight-medium">{{ selectedReview.teacherName }}</span>
        </div>
        
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-calendar-range</v-icon>
          <span class="font-weight-medium">{{ selectedReview.startDate }} ~ {{ endDate }}</span>
        </div>
      </div>
      
      <!-- Rating Section -->
      <div class="review-rating-section mb-4">
        <div class="mb-2">
          <span class="subtitle-1 font-weight-medium">평점</span>
        </div>
        <v-rating
          empty-icon="$mdiStarOutline"
          full-icon="$mdiStar"
          half-icon="$mdiStarHalfFull"
          half-increments
          hover
          length="5"
          size="24"
          v-model="selectedReview.rating"
          color="amber darken-2"
          background-color="grey lighten-2"
        ></v-rating>
      </div>
    </v-card-text>

    <!-- Review Content Section -->
    <v-row class="px-4">
      <v-col cols="12" :md="isManager || !selectedReview.createdAt ? 6 : 12">
        <div class="review-content-section">
          <div class="d-flex align-center mb-2">
            <v-icon color="primary" class="mr-2">mdi-comment-text-outline</v-icon>
            <span class="subtitle-1 font-weight-medium">수강 후기</span>
          </div>
          <v-textarea
            :rules="minimumLengthRule(30)"
            counter
            filled
            auto-grow
            rows="7"
            row-height="12"
            label="소중한 수강후기를 남겨주세요. (30자 이상)"
            placeholder=""
            :value="selectedReview.reviewText"
            v-model="selectedReview.reviewText"
            class="review-textarea"
            hide-details="auto"
          ></v-textarea>
        </div>
      </v-col>
      
      <v-col cols="12" :md="isManager || !selectedReview.createdAt ? 6 : 12" v-if="isManager || !selectedReview.createdAt">
        <div class="review-feedback-section">
          <div class="d-flex align-center mb-2">
            <v-icon color="primary" class="mr-2">mdi-comment-question-outline</v-icon>
            <span class="subtitle-1 font-weight-medium">개선할 점</span>
          </div>
          <v-textarea
            counter
            filled
            auto-grow
            rows="7"
            row-height="12"
            label="이용하시면서 불편했던 점을 남겨주세요."
            placeholder="개선할 수 있는 부분은 최대한 반영하겠습니다. 감사합니다 :)"
            :value="selectedReview.feedback"
            v-model="selectedReview.feedback"
            class="feedback-textarea"
            hide-details="auto"
          ></v-textarea>
        </div>
      </v-col>
    </v-row>

    <!-- Submit Button -->
    <v-card-actions class="pa-4">
      <v-btn
        v-if="isShowSubmit"
        elevation="2"
        color="primary"
        rounded
        min-width="120"
        @click="$emit('saveReview', selectedReview)"
      >
        <v-icon left>mdi-check</v-icon>
        제출
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapGetters} from "vuex";
import {parseDate} from "@/utils/common_date";

export default {
  name: 'CardReview',
  components: {},
  props: {
    selectedReview: {type: Object}
  },
  data() {
    return {
      min: 30,
      rating: 3,
      searchQuery: {
        orderId: ''
      },
      assign: {},
    };
  },
  created() {
    this.selectedReview.rating=5.0

  },
  mounted() {
  },
  computed: {
    ...mapGetters(['app', 'user', 'isManager']),

    minimumLengthRule() {
      return (min) => {
        const rules = []
        const rule = v => (v || '').length >= min ||
            `최소 ${min}자 이상은 작성 부탁드릴게요! :) `
        rules.push(rule)
        return rules
      }
    },
    endDate() {
      return this.assign ? parseDate(this.selectedReview.endDate, '{y}-{m}-{d}') : ''
    },
    isShowSubmit(){
      if (this.selectedReview.createdAt) {
        let dateModifyLimit = new Date(this.selectedReview.createdAt).setDate(new Date(this.selectedReview.createdAt).getDate() + 3)
        let nowDate = new Date()

        return dateModifyLimit > nowDate
      }
      return true;
    }
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>
.card-review-container {
  border-radius: 12px;
  overflow: hidden;
}

.review-info-section {
  background-color: rgba(59, 130, 246, 0.05);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.review-rating-section {
  margin-bottom: 24px;
}

.review-content-section,
.review-feedback-section {
  margin-bottom: 24px;
}

.review-textarea,
.feedback-textarea {
  border-radius: 8px;
  
  ::v-deep .v-input__slot {
    background-color: rgba(0, 0, 0, 0.02) !important;
  }
}

// Media queries for responsive design
@media (max-width: 960px) {
  .review-info-section {
    padding: 12px;
  }
}
</style>
